/**
 * Post Shift Feedback API Contract
 *
 * Defines the oRPC contract for post-shift feedback -
 * employee feedback submitted after completing a shift.
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreatePostShiftFeedbackInputSchema, UpdatePostShiftFeedbackInputSchema, PostShiftFeedbackResponseSchema, } from "@hourly/api/postShiftFeedback";
import { uuidSchema } from "@hourly/api/validation-common";
// ============ Contract Definitions ============
// Create feedback for a shift
const createPostShiftFeedback = oc
    .route({
    method: "POST",
    path: "/post-shift-feedback/{shiftId}",
    summary: "Create post-shift feedback",
    tags: ["Post Shift Feedback"],
    successStatus: 201,
})
    .input(z.object({ shiftId: uuidSchema }).merge(CreatePostShiftFeedbackInputSchema))
    .output(PostShiftFeedbackResponseSchema);
// Update feedback for a shift
const updatePostShiftFeedback = oc
    .route({
    method: "PUT",
    path: "/post-shift-feedback/{shiftId}",
    summary: "Update post-shift feedback",
    tags: ["Post Shift Feedback"],
})
    .input(z.object({ shiftId: uuidSchema }).merge(UpdatePostShiftFeedbackInputSchema))
    .output(PostShiftFeedbackResponseSchema);
// Get feedback for a shift
const getPostShiftFeedback = oc
    .route({
    method: "GET",
    path: "/post-shift-feedback/{shiftId}",
    summary: "Get post-shift feedback for a shift",
    tags: ["Post Shift Feedback"],
})
    .input(z.object({ shiftId: uuidSchema }))
    .output(PostShiftFeedbackResponseSchema);
// ============ Export Contract ============
export const postShiftFeedbackContract = {
    create: createPostShiftFeedback,
    update: updatePostShiftFeedback,
    get: getPostShiftFeedback,
};
//# sourceMappingURL=postShiftFeedback.js.map